import { $, $$ } from '@starberry/components';
import PageHero from './PageHero';

export default {
  $: PageHero,

  props: {
    px: $('theme.space.12'),
    d: ['flex'],
    flexDirection: 'row',
  },

  primary: [
    {
      $: 'Avatar',
      props: { w: '80px', h: '80px', mr: [5, null, 8], d: ['flex', null, null, null, 'none'] },
    },
  ],

  secondary: [
    {
      $: 'H5',
      props: {
        d: 'flex',
        fontWeight: 'normal',
        fontSize: $$(
          ('constants.headings.headingSize.h5'),
          null,
          ('constants.headings.headingSize.h3'),
        ),
        lineHeight: $$(
          ('constants.headings.headingLineHeight.h5'),
          null,
          ('constants.headings.headingLineHeight.h3'),
        ),
      },
      children: [
        { $: 'Text', props: { as: 'span' }, children: 'Welcome back,' },
        {
          $: 'Flex',
          provide: ['auth'],
          children: (_, context) => ({
            $: 'Text',
            props: {
              as: 'span',
              ml: 2,
            },
            children: context?.state?.auth?.[0]?.user?.name || 'Visitor',
          }),
        },
      ],
    },
    { $: 'UserPendingActionsText' },
  ],
};
